import {
  STATUS_APPROVED,
  STATUS_CANCELED_ADM,
  STATUS_CANCELED_EE,
  STATUS_CANCEL_OFFERED,
  STATUS_CANCEL_SUBMITTED,
  STATUS_DECLINED,
  STATUS_EXPIRED_ADM,
  STATUS_EXPIRED_EE,
  STATUS_OFFERED,
  STATUS_REFUSED,
  STATUS_RETRACTED,
  STATUS_SUBMITTED,
  TRADE_TYPE,
  LAST_UPDATED,
  STATUS,
  ACQUIRED_SHIFT
} from "./constants";
import { getEarliestShift } from "./tradeFormEventHelper";

const tradeStatuses = [
  STATUS_OFFERED,
  STATUS_CANCEL_OFFERED,
  STATUS_SUBMITTED,
  STATUS_CANCEL_SUBMITTED,
  STATUS_EXPIRED_ADM,
  STATUS_EXPIRED_EE,
  STATUS_APPROVED,
  STATUS_CANCELED_ADM,
  STATUS_CANCELED_EE,
  STATUS_REFUSED,
  STATUS_DECLINED,
  STATUS_RETRACTED,
];

const adminTradeStatuses = [
  STATUS_SUBMITTED,
  STATUS_CANCEL_SUBMITTED,
  STATUS_EXPIRED_ADM,
  STATUS_APPROVED,
  STATUS_CANCEL_OFFERED,
  STATUS_CANCELED_ADM,
  STATUS_CANCELED_EE,
  STATUS_EXPIRED_EE,
  STATUS_OFFERED,
  STATUS_REFUSED,
  STATUS_DECLINED,
  STATUS_RETRACTED,
];

export function getTradeStatusCustomComparator(statusFromMobile1, statusFromMobile2, trade1, trade2, eid) {
  let trade1Row;
  let trade2Row;
  let trade1Status;
  let trade2Status;
  if (isCallFromMobile(trade1)) {
    trade1Row = trade1;
    trade2Row = trade2;
    trade1Status = statusFromMobile1;
    trade2Status = statusFromMobile2;
  } else {
    trade1Row = trade1.api.getRow(trade1.id);
    trade2Row = trade2.api.getRow(trade2.id);
    trade1Status = trade1Row[trade1.field];
    trade2Status = trade2Row[trade2.field];
  }
  if (trade1Status === STATUS_OFFERED && trade2Status === STATUS_OFFERED) {
    if (trade1Row.offeredEmployeeId === eid) {
      return trade2Row.offeredEmployeeId === eid ? 0 : 1;
    } else {
      return trade2Row.offeredEmployeeId === eid ? -1 : 0;
    }
  }
  if (trade1Status === STATUS_CANCEL_OFFERED && trade2Status === STATUS_CANCEL_OFFERED) {
    if (trade1Row.modifiedByEid === eid) {
      return trade2Row.modifiedByEid === eid ? 0 : 1;
    } else {
      return trade2Row.modifiedByEid === eid ? -1 : 0;
    }
  }
  if (trade1Status === STATUS_CANCEL_OFFERED && trade2Status === STATUS_OFFERED) {
    if (trade1Row.modifiedByEid === eid) {
      return 1;
    } else {
      return trade2Row.offeredEmployeeId === eid ? -1 : 1;
    }
  }
  if (trade1Status === STATUS_OFFERED && trade2Status === STATUS_CANCEL_OFFERED) {
    if (trade1Row.offeredEmployeeId === eid) {
      return trade2Row.modifiedByEid === eid ? -1 : 1;
    } else {
      return -1;
    }
  }
  if (trade1Status === trade2Status) {
    return 0;
  }
  return tradeStatuses.indexOf(trade1Status) > tradeStatuses.indexOf(trade2Status) ? 1 : -1;
}

function isCallFromMobile(trade) {
  if (trade.api) {
    return false;
  }
  return true;
}

export function getAdminTradeStatusCustomComparator(tradeStatus1, tradeStatus2, trade1, trade2) {
  let trade1Row = trade1.api.getRow(trade1.id);
  let trade2Row = trade2.api.getRow(trade2.id);
  let trade1Status = trade1Row[trade1.field];
  let trade2Status = trade2Row[trade2.field];
  if (trade1Status === trade2Status) {
    return 0;
  }
  return adminTradeStatuses.indexOf(trade1Status) > adminTradeStatuses.indexOf(trade2Status) ? 1 : -1;
}

export function getTradeOfferedEmployeeLastNameCustomComparator(test1, test2, trade1, trade2) {
  let trade1Row = trade1.api.getRow(trade1.id);
  let trade2Row = trade2.api.getRow(trade2.id);
  if (trade1Row.offeredEmployeeLastName === trade2Row.offeredEmployeeLastName) {
    if (trade1Row.offeredEmployeeFirstName === trade2Row.offeredEmployeeFirstName) {
      return 0;
    }
    return trade1Row.offeredEmployeeFirstName > trade2Row.offeredEmployeeFirstName ? 1 : -1;
  }
  return trade1Row.offeredEmployeeLastName > trade2Row.offeredEmployeeLastName ? 1 : -1;
}

export function getTradeOfferedEmployeeShiftCustomComparator(test1, test2, trade1, trade2) {
  let trade1Row = trade1.api.getRow(trade1.id);
  let trade2Row = trade2.api.getRow(trade2.id);
  let trade1EarliestShift = getEarliestShift(trade1Row);
  let trade2EarliestShift = getEarliestShift(trade2Row);
  if (
    trade1EarliestShift.year === trade2EarliestShift.year &&
    trade1EarliestShift.month === trade2EarliestShift.month &&
    trade1EarliestShift.day === trade2EarliestShift.day &&
    trade1EarliestShift.hour === trade2EarliestShift.hour &&
    trade1EarliestShift.minute === trade2EarliestShift.minute
  ) {
    return 0;
  }
  return trade1EarliestShift.toMillis() > trade2EarliestShift.toMillis() ? 1 : -1;
}

export function getLastUpdatedCustomComparator(tradeCreatedAt1, tradeCreatedAt2, trade1, trade2) {
  if (!trade1) {
    tradeCreatedAt1 = tradeCreatedAt1.createdAt;
    tradeCreatedAt2 = tradeCreatedAt2.createdAt;
  }
  if (
    tradeCreatedAt1.year === tradeCreatedAt2.year &&
    tradeCreatedAt1.month === tradeCreatedAt2.month &&
    tradeCreatedAt1.day === tradeCreatedAt2.day &&
    tradeCreatedAt1.hour === tradeCreatedAt2.hour &&
    tradeCreatedAt1.minute === tradeCreatedAt2.minute
  ) {
    return 0;
  }
  return tradeCreatedAt1.toMillis() < tradeCreatedAt2.toMillis() ? -1 : 1;
}

export function getAccessExceptionsLastUpdatedCustomComparator(dateTime1, dateTime2) {
  if (dateTime1.year === dateTime2.year && dateTime1.month === dateTime2.month && dateTime1.day === dateTime2.day) {
    return 0;
  }
  return dateTime1.ts - dateTime2.ts;
}

export function getAccessExceptionsEmployeeIdCustomComparator(userEid1, userEid2, userRow1, userRow2) {
  if (!userRow1) {
    userEid1 = userEid1.createdAt;
    userEid2 = userEid2.createdAt;
  }
  let userEid1Int = parseInt(userEid1.slice(1));
  let userEid2Int = parseInt(userEid2.slice(1));
  if (userEid1Int === userEid2Int) {
    return 0;
  }
  return userEid1Int < userEid2Int ? -1 : 1;
}

export function getAccessExceptionsEmployeeNameCustomComparator(nothing, nothing2, row1, row2) {
  let userAccess1Row = row1.api.getRow(row1.id);
  let userAccess2Row = row2.api.getRow(row2.id);
  if (
    userAccess1Row.lastName + ", " + userAccess1Row.firstName ===
    userAccess2Row.lastName + ", " + userAccess2Row.firstName
  ) {
    return 0;
  }
  return userAccess1Row.lastName + ", " + userAccess1Row.firstName <
    userAccess2Row.lastName + ", " + userAccess2Row.firstName
    ? -1
    : 1;
}

export function getAccessExceptionsIsRoleCustomComparator(bool1, bool2) {
  return bool1 ? (bool2 ? 0 : -1) : bool2 ? 1 : 0;
}

export function sortTradesByFilter(sortValue, sortedTrades, eid) {
  switch (sortValue) {
    case TRADE_TYPE:
      sortedTrades = sortedTrades.sort((a, b) => {
        return b.tradeFormType > a.tradeFormType ? -1 : 1;
      });
      break;
    case STATUS:
      sortedTrades = sortedTrades.sort((a, b) => {
        return getTradeStatusCustomComparator(a.tradeStatus, b.tradeStatus, a, b, eid);
      });
      break;
    case LAST_UPDATED:
      sortedTrades = sortedTrades.sort((a, b) => {
        return b.createdAt.toMillis() - a.createdAt.toMillis();
      });
      break;
    case ACQUIRED_SHIFT:
      sortedTrades = sortedTrades.sort((a, b) => {
        return b.offeredShiftStart.toMillis() > a.offeredShiftStart.toMillis() ? -1 : 1;
      });
      break;
    default:
      break;
  }
  return sortedTrades;
}